// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_PHOTO = "Naozaj chce\u0161 zmaza\u0165 fotku?";
export const PHOTO_HAS_BEEN_DELETED = "Fotka bola zmazan\u00e1.";
